import {IActionModel} from "../../shared/models/action.model";
import {IUser} from "../../shared/models/user.model";
import {
    GET_ALL_PROVIDERS_LIST,
    GET_SYSTEM_SETTINGS_DETAILS,
    SET_ALL_PROVIDERS_LIST,
    SET_SYSTEM_SETTINGS_DETAILS
} from "../actions/user.action";

export interface IUserReducerState {
    allProvidersList: IUser[],
    isAllProvidersListLoading: boolean,
    isAllProvidersListLoaded: boolean,
    isSystemSettingsDetailsLoading: boolean,
    isSystemSettingsDetailsLoaded: boolean,
    systemSettingsDetails: any,
}


const initialData: IUserReducerState = {
    allProvidersList: [],
    isAllProvidersListLoading: false,
    isAllProvidersListLoaded: false,
    isSystemSettingsDetailsLoading: false,
    isSystemSettingsDetailsLoaded: false,
    systemSettingsDetails: undefined,
};

const UserReducer = (state = initialData, action: IActionModel): IUserReducerState => {
    switch (action.type) {
        case GET_ALL_PROVIDERS_LIST:
            state = {
                ...state,
                isAllProvidersListLoading: true,
                isAllProvidersListLoaded: false,
            };
            return state;
        case SET_ALL_PROVIDERS_LIST:
            state = {
                ...state,
                isAllProvidersListLoading: false,
                isAllProvidersListLoaded: true,
                allProvidersList: action.payload.allProvidersList
            };
            return state;
        case GET_SYSTEM_SETTINGS_DETAILS:
            state = {
                ...state,
                isSystemSettingsDetailsLoading: true,
                isSystemSettingsDetailsLoaded: false,
            };
            return state;
        case SET_SYSTEM_SETTINGS_DETAILS:
            state = {
                ...state,
                isSystemSettingsDetailsLoading: false,
                isSystemSettingsDetailsLoaded: true,
                systemSettingsDetails: action.payload.systemSettingsDetails
            };
            return state;
        default:
            return state;
    }
};

export default UserReducer;
